import { render, staticRenderFns } from "./MobilePhoneInput.vue?vue&type=template&id=1321e8da&scoped=true&"
import script from "./MobilePhoneInput.vue?vue&type=script&lang=js&"
export * from "./MobilePhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./MobilePhoneInput.vue?vue&type=style&index=0&id=1321e8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_qqg2mlm7tcp4cjng2lo6klgciy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321e8da",
  null
  
)

export default component.exports